import React from 'react';

export default ({ children, titoloSezione }) => (
    <section className="container primo-piano">
        {titoloSezione && <h1>{titoloSezione}</h1>}
        <div className="px-custom">
            {children}
        </div>
    </section>
);



